import { FC } from 'react';

import styles from './styles.module.scss';

export const SkeletonTimelineSchedule: FC = () => {
  const columns = [4, 3, 2, 5, 2, 3, 5, 2, 1, 3];

  return (
    <div className={styles['skeleton-schedule']}>
      {columns.map((cardsCount, columnIndex) => (
        <div key={columnIndex} className={styles['skeleton-schedule__row']}>
          <div style={{ display: 'flex' }}>
            <div className={styles['skeleton-schedule__date']}></div>
            <div className={styles['skeleton-schedule__time']}></div>
            <div>
              {Array(cardsCount)
                .fill(null)
                .map((_, cardIndex) => (
                  <div
                    key={cardIndex}
                    className={styles['skeleton-schedule__card']}
                  />
                ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
